module.exports = __webpack_public_path__ + "static/media/photo4.3b9bab24.jpg";